import * as api from '@/api/global'
import * as TYPES from './type';

export default {
  async getKzjxCourseList ({ commit, state }, cb) {
    const result = await api.reqKzjxCourseList()
    commit(TYPES.GLOBAL_COURSE, { result })
    cb && cb()
  },
  async getjxCourseList ({ commit, state }, cb) {
    const result = await api.reqjxCourseList()
    commit(TYPES.GLOBAL_COURSE, { result })
    cb && cb()
  },
  async getjxClassList ({ commit, state }, {paramets, cb}) {
    const result = await api.reqjxClassList(paramets)
    commit(TYPES.GLOBAL_CLASS, { result })
    cb && cb()
  },
  async postDeleteFile ({ commit, state }, {paramets, cb}) {
    const result = await api.reqDeleteFile(paramets)
    commit(TYPES.GLOBAL_DELFILE, { result })
    cb && cb()
  },
  async getTestSelectDegree ({commit}, {paramets, cb}) {
    const result = await api.reqTestSelect(paramets)
    commit(TYPES.GLOBAL_TEST_DEGREE, result)
    cb && cb()
  },
  async getTestSelectType ({commit}, {paramets, cb}) {
    const result = await api.reqTestSelect(paramets)
    commit(TYPES.GLOBAL_TEST_TYPE, result)
    cb && cb()
  },
  async postUploadFile ({ commit, state }, {paramets, cb}) {
    const result = await api.reqUploadFile(paramets)
    commit(TYPES.GLOBAL_UPLOAD, { result })
    cb && cb()
  },
  async postTestAdd ({ commit, state }, {paramets, cb}) {
    const result = await api.reqTestAdd(paramets)
    commit(TYPES.GLOBAL_TEST_ADD, { result })
    cb && cb()
  },
  async putTestEdit ({ commit, state }, {paramets, cb}) {
    const result = await api.reqTestEdit(paramets)
    commit(TYPES.GLOBAL_TEST_EDIT, { result })
    cb && cb()
  },
  async getTestList ({ commit, state }, {paramets, cb}) {
    const result = await api.reqTestList(paramets)
    commit(TYPES.GLOBAL_TEST_LIST, { result })
    cb && cb()
  },
  async getDownExcel ({ commit, state }, {paramets, cb}) {
    const result = await api.reqDownExcel(paramets)
    commit(TYPES.GLOBAL_DOWN_EXCEL, { result })
    cb && cb()
  },
  async delTestList ({ commit, state }, {paramets, cb}) {
    const result = await api.reqTestListDel(paramets)
    commit(TYPES.GLOBAL_TEST_DEL, { result })
    cb && cb()
  },
}


// WEBPACK FOOTER //
// ./src/store/global/actions.js